// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2LMya","head":"Table_head__Skf6l","col":"Table_col__1R0L6"};